import { onLanguageChange } from "@opendash/i18n";
import Highcharts from "highcharts";

require("highcharts/highcharts-more")(Highcharts);
require("highcharts-regression")(Highcharts);
require("highcharts/modules/boost")(Highcharts);
require("highcharts/modules/drilldown")(Highcharts);
require("highcharts/modules/heatmap")(Highcharts);
require("highcharts/modules/tilemap")(Highcharts);
require("highcharts/modules/map")(Highcharts);
require("highcharts/modules/histogram-bellcurve")(Highcharts);
require("highcharts/modules/solid-gauge")(Highcharts);
require("highcharts/modules/sankey")(Highcharts);
require("highcharts/modules/sunburst")(Highcharts);
require("highcharts/modules/treemap")(Highcharts);
require("highcharts/modules/gantt")(Highcharts);
require("highcharts/modules/dependency-wheel")(Highcharts);
require("highcharts/modules/networkgraph")(Highcharts);

const monthsA = [];
const shortMonthsA = [];
const weekdaysA = [];
const shortWeekdaysA = [];
const zoom1 = "";
const zoom2 = "";

onLanguageChange((lang) => {
  let zoom1 = "Reset Zoom";
  let zoom2 = "Reset to Zoom Level 1";
  let monthsA = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  let shortMonthsA = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let weekdaysA = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let shortWeekdaysA = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  if (lang === "de") {
    zoom1 = "Zurücksetzen des Zooms";
    zoom2 = "Zoom Level 0";
    monthsA = [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "Augsut",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ];
    shortMonthsA = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez",
    ];
    weekdaysA = [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ];
    shortWeekdaysA = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
  }
  if (lang === "nl") {
    zoom1 = "Zoom Resetten";
    zoom2 = "Zoomniveau 0";
    monthsA = [
      "Januari",
      "Februari",
      "Maart",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Augustus",
      "September",
      "Oktober",
      "November",
      "December",
    ];
    shortMonthsA = [
      "Jan",
      "Feb",
      "Mrt",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dec",
    ];
    weekdaysA = [
      "Zondag",
      "Maandag",
      "Dinsdag",
      "Woensdag",
      "Donderdag",
      "Vrijdag",
      "Zaterdag",
    ];
    shortWeekdaysA = ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"];
  }
  window.Highcharts.setOptions({
    lang: {
      resetZoom: zoom1,
      resetZoomTitle: zoom2,
      months: monthsA,
      weekdays: weekdaysA,
      shortWeekdays: shortWeekdaysA,
      shortMonths: shortMonthsA,
    },
  });
});

window.Highcharts = Highcharts;
window.Highcharts.setOptions({
  time: {
    useUTC: false,
    timezone: "Europe/Berlin",
    timezoneOffset: new Date().getTimezoneOffset(),
  },
  boost: {
    useGPUTranslations: false,
    // TODO: Typescript fehler
    // useAlpha: false,
    enabled: true,
  },
  global: {
    // TODO: Typescript fehler
    // useUTC: false,
  },
  // TODO: Typescript fehler
  // series: {
  //   turboThreshold: 1,
  // },
  lang: {
    resetZoom: zoom1,
    resetZoomTitle: zoom2,
    months: monthsA,
    weekdays: weekdaysA,
    shortWeekdays: shortWeekdaysA,
    shortMonths: shortMonthsA,
  },
});
